import PetBuilderStore, {
  PetBuilderContext,
} from "../../../storeroom/pets/builder/PetBuilderStore";
import { useContext } from "react";

export function usePetBuilderStore(): PetBuilderStore {
  return useContext(PetBuilderContext);
}
